export class RunContext {
    constructor() { this.cancelled = false; }
    cancel() { this.cancelled = true; }
}
